import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PasswordResetService} from '../../../../services/user/password-reset.service';

@Component({
  selector: 'app-password-reset-token',
  styleUrls: ['./password-reset-token.component.scss'],
  templateUrl: './password-reset-token.component.html',
})
export class PasswordResetTokenComponent implements OnInit {

  public emailForm: FormGroup;
  public isSuccessful = false;
  public errorMessage: string;

  constructor(private formBuilder: FormBuilder,
              private passwordResetService: PasswordResetService) {
    console.log('Password reset token form constructor');
  }

  public onSubmit(): void {
    console.log('Password reset token form submit');
    this.passwordResetService.sendPasswordResetEmail(this.emailForm.controls.email.value)
      .subscribe({
        next: () => {
          this.isSuccessful = true;
        },
        error: (err) => {
          this.isSuccessful = false;
          this.errorMessage = err.error.message;
        },
      });
  }

  ngOnInit(): void {
    console.log('Password reset token form init');
    this.emailForm = this.formBuilder.group({email: ['', Validators.required]});
  }
}
